import React from 'react';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

import TallyItem from './TallyItem';
import AddButton from './AddButton';
import ResetButton from './ResetButton';
import {ListsContext} from '../App';

export default function TallyList() {
  return (
    <ListsContext.Consumer>
      {
        (context) => {
          let list = context.list;

          return (<Container maxWidth="sm">
            <Typography variant="h3" component="h2" gutterBottom className="tally-list-name" align="center">
              {list.name}
            </Typography>
            <div className="app-panel">
              <Typography variant="body2" component="p" className="last-reset" gutterBottom>
                Last reset: {list.lastReset.toLocaleString()}
              </Typography>
              <ResetButton />
            </div>
            <List className="tally-list" id="tallies">
              {
                list.items.map((item, index) => (<TallyItem
                  item={item}
                  index={index}
                  key={index + Date.now().toString()} />)
                )
              }
            </List>
            <AddButton onAdd={context.addItem} />
          </Container>);
        }
      }
    </ListsContext.Consumer>
  );
}